import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  designer: null,
  sewing: null,
  manager: null,
  loadingEmployee: false,
};

const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    getDesigner(state, action) {
      state.loadingEmployee = false;
      state.designer = action.payload;
      state.loadingEmployee = true;
    },
    getSewing(state, action) {
      state.loadingEmployee = false;
      state.sewing = action.payload;
      state.loadingEmployee = true;
    },
    getManager(state, action) {
      state.loadingEmployee = false;
      state.manager = action.payload;
      state.loadingEmployee = true;
    },
  },
});

export default employeeSlice.reducer;
export const { getDesigner, getSewing, getManager } = employeeSlice.actions;
